import { Message } from 'element-ui';
import * as utils from '@/project/utils';
// 获取中国时区时间
export let isConsult = (item) => {
  let user = JSON.parse(sessionStorage.getItem('userInfo'));
  // if(item.userid==user.id){

  // }else{
  // 	return false
  // }
  return false;
};
export const isMobile = () => {
  let userAgent = navigator.userAgent;
  let mobileTypes = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let arr = mobileTypes.filter((i) => userAgent.includes(i));
  return !!arr.length;
};

export const goLogin = (vue) => {
  const token = sessionStorage.getItem('token');
  if (!token) {
    // vue.$message('请先登录');
    vue.$router.push({ path: '/login' });
    return true;
  }
  return false;
};

export const formatDate = (date, fmt) => {
  var o = {
    'M+': date.getMonth() + 1, //月份
    'D+': date.getDate(), //日
    'H+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
};

export const compareDate = (time) => {
  const timestamp = new Date().getTime();
  var endtimestamp = Date.parse(time);
  if (!endtimestamp || endtimestamp < timestamp) {
    return false;
  } else {
    return true;
  }
};

export default {
  ...utils,
  isMobile,
  goLogin,
  formatDate,
  compareDate,
};
